import { defineComponent, onMounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import CurrencyCode from '@/presentation/components/campaign-settings/currency/currency.code';

export default defineComponent({
	components: {
		MultiSelect
	},
	setup: () => {
		const code = new CurrencyCode();

		onMounted(code.mounted.bind(code));

		return {
			currencyDropdown: code.currencyDropdown,
			options: code.options,
			currency: code.currency,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isCampaignCreation: code.isCampaignCreation,
			setCurrency: code.setCurrency.bind(code)
		};
	}
});
